"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DetailItemShare = void 0;
var ShareItemClickEvent = _interopRequireWildcard(require("@ori-events/share-item-click"));
var _analyticsData = require("@ori/analytics-data");
var _environment = require("@ori/environment");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _constants = require("../../constants");
var _components = require("./components");
var _constants2 = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DetailItemShare = ({
  itemId
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const sharedUrl = (0, _react.useMemo)(() => `${window.location.href.split('#')[0]}#opi${itemId}`, [itemId]);
  const filteredSocialIcons = (0, _react.useMemo)(() => {
    if (_constants.vkMarkets.includes(tenant)) {
      return _constants2.allowedSocialPlatforms.filter(kind => kind !== 'facebook');
    }
    return _constants2.allowedSocialPlatforms.filter(kind => kind !== 'vkontakte');
  }, [tenant]);
  const onShare = (0, _react.useCallback)(method => () => {
    const customEvent = new CustomEvent(ShareItemClickEvent.Name, {
      detail: {
        method,
        contentType: _analyticsData.ContentType.Photo,
        placement: _analyticsData.Placement.OlapicWidget,
        itemCode: itemId
      }
    });
    window.dispatchEvent(customEvent);
  }, [itemId]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    "data-testid": getTestId(_constants2.DETAIL_ITEM_SHARE),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Inner, {
      children: filteredSocialIcons.map(kind => /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SocialShareIcon, {
        kind: kind,
        sharedUrl: sharedUrl,
        onClick: onShare(kind)
      }, kind))
    })
  });
};
exports.DetailItemShare = DetailItemShare;
